"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
const icons_1 = require("@kyruus/select/select/dist/icons");
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const provider_1 = require("../../../lib/constants/provider");
const messages_1 = __importDefault(require("../../../lib/messages"));
const LocationDropdownItem_1 = __importDefault(require("./LocationDropdownItem"));
const styles_1 = require("./styles");
/**
 * Function to get the location name based on the location object
 *
 * @param {object} location Location object
 * @returns
 */
const getLocationName = (location) => {
    return location.name ? location.name : location.street1;
};
/**
 * Function to check if current passed location needs to be disabled
 *
 * @param {object} currentLocation Selected/current location
 * @param {Array<object>} selectedLocations All the selected locations
 *
 * @returns {boolean} True if location is to be disabled, false otherwise
 */
const isLocationDisabled = (currentLocation, selectedLocations) => {
    return ((selectedLocations.size === 1 &&
        selectedLocations.has(currentLocation.id)) ||
        currentLocation.type === provider_1.LOCATION_TYPES.NON_BOOKABLE);
};
/**
 * Function to handle the selection of location
 *
 * @param {object} currentLocation Selected/current location
 * @param {Array<object>} selectedLocations All the selected locations
 * @param {Function} onSelect Callback function to handle the selection of location
 *
 * @returns {null}
 */
const onSelectWrapper = (currentLocation, selectedLocations, onSelect) => {
    // disable click event for non-bookable locations or disabled locations
    if (!currentLocation ||
        isLocationDisabled(currentLocation, selectedLocations)) {
        return false;
    }
    onSelect(selectedLocations, currentLocation.id);
};
/**
 * LocationsDropDown component
 *
 * @param {object} param0 Input props for the component
 * @param {Array<object>} param0.selectedLocationIds All the selected locations
 * @param {Array<object>} param0.bookableLocations All the bookable locations
 * @param {Array<object>} param0.nonBookableLocations All the non-bookable locations
 * @param {object} param0.intl Intl object
 * @param {string} param0.locationId Location ID
 * @param {Function} param0.onSelect Callback function to handle the selection of location
 *
 * @returns {React.Component} LocationsDropDown component
 */
const LocationsDropDown = ({ selectedLocationIds, bookableLocations, locationId, intl, nonBookableLocations, onSelect }) => {
    let selectedLocations = selectedLocationIds;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [focusIndex, setFocusIndex] = (0, react_1.useState)(null);
    const handleFocusOnKeyDown = (event, idx) => {
        event.preventDefault();
        if (event.code === 'ArrowDown') {
            setFocusIndex((idx + 1) % items.length);
        }
        else if (event.code === 'ArrowUp') {
            setFocusIndex((items.length + idx - 1) % items.length);
        }
    };
    const handleOpenMenu = (ev) => {
        setAnchorEl(ev.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // Merging bookable and non-bookable locations
    // to display them in the dropdown
    const items = (0, react_1.useMemo)(() => [
        ...bookableLocations.map((item) => {
            item.type = provider_1.LOCATION_TYPES.BOOKABLE;
            return item;
        }),
        ...nonBookableLocations.map((item) => {
            item.type = provider_1.LOCATION_TYPES.NON_BOOKABLE;
            return item;
        })
    ], [bookableLocations, nonBookableLocations]);
    // If locationId is passed from deep link, select that location
    const findSelectedIdInBookableLocations = bookableLocations.find((loc) => locationId && loc.id.toString() === locationId.toString());
    if (findSelectedIdInBookableLocations === null || findSelectedIdInBookableLocations === void 0 ? void 0 : findSelectedIdInBookableLocations.id) {
        selectedLocations = new Set([findSelectedIdInBookableLocations === null || findSelectedIdInBookableLocations === void 0 ? void 0 : findSelectedIdInBookableLocations.id]);
    }
    // Function to get the display value
    // for the dropdown based on the selected locations
    const getDisplayValue = (0, react_1.useCallback)(() => {
        let displayValue = null;
        if (bookableLocations.every((location) => selectedLocations.has(location.id))) {
            displayValue = intl.formatMessage(messages_1.default.allLocations);
        }
        else if (selectedLocations.size >= 1) {
            const selectedLocation = Array.from(selectedLocations).at(0);
            const selectedLocationObj = bookableLocations.filter((loc) => loc.id.toString() === selectedLocation.toString());
            displayValue = `${getLocationName(selectedLocationObj[0])}`;
            if (selectedLocations.size > 1) {
                displayValue += ', +' + (selectedLocations.size - 1);
            }
        }
        return displayValue;
    }, [selectedLocations, bookableLocations, intl]);
    return (react_1.default.createElement(styles_1.LocationDropdownContainer, { "data-testid": "locations-dropdown" },
        react_1.default.createElement(styles_1.StyledLabel, { "data-testid": "locations-dropdown-label" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.location))),
        react_1.default.createElement(styles_1.StyledButton, { type: "button", mode: "secondary", onClick: handleOpenMenu, "aria-expanded": Boolean(anchorEl), "aria-haspopup": "menu", "aria-controls": "checkselect-menu", "aria-label": intl.formatMessage(messages_1.default.ariaFilterByLocation) },
            react_1.default.createElement("span", null, getDisplayValue()),
            react_1.default.createElement(icons_1.ArrowDown, null,
                react_1.default.createElement(ArrowDown_1.default, null))),
        react_1.default.createElement(styles_1.StyledMenu, { keepMounted: true, "data-testid": "checkselect-menu", anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: {
                id: 'checkselect-menu',
                disabledItemsFocusable: true
            } }, items.map((location, idx) => {
            return (react_1.default.createElement(styles_1.StyledMenuItem, { key: location.id, 
                // Disabled autoFocus as we are managing focus manually for arrow up and down
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: idx === focusIndex, onKeyDown: (event) => handleFocusOnKeyDown(event, idx), onClick: (event) => {
                    event.preventDefault();
                    onSelectWrapper(location, selectedLocations, onSelect);
                }, "aria-checked": selectedLocations.has(location.id), "aria-disabled": isLocationDisabled(location, selectedLocations), disableRipple: true, role: "menuitemcheckbox" },
                react_1.default.createElement(LocationDropdownItem_1.default, { location: location, isSelected: selectedLocations.has(location.id), isDisabled: isLocationDisabled(location, selectedLocations), onSelect: () => onSelectWrapper(location, selectedLocations, onSelect) })));
        }))));
};
const LocationProp = (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    name: prop_types_1.string,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string
}));
LocationsDropDown.propTypes = {
    bookableLocations: LocationProp.isRequired,
    nonBookableLocations: LocationProp.isRequired,
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    locationId: prop_types_1.string,
    selectedLocationIds: (0, prop_types_1.instanceOf)(Set).isRequired,
    onSelect: prop_types_1.func.isRequired
};
exports.default = (0, intl_1.injectIntl)(LocationsDropDown);
//# sourceMappingURL=LocationsDropdown.js.map